import 'date-fns'
import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Accordion, AccordionDetails, AccordionSummary, FormControl, Grid, TextField } from '@material-ui/core'
import { CompanyReceiptsFormValidation } from '../../../../utils/validationSchema'
import { useStyles } from '../../Styles'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import arSA from 'date-fns/locale/ar-SA'
import enUS from 'date-fns/locale/en-US'
import { lg } from '../../../../utils/ResponsiveUtility'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { LanguageConsumer } from '../../../../LanguageContext'


const ReceiptsFilter = ({ submitForm }) => {
  const classes = useStyles()
  const intl = useIntl()
  const [selectedDateFrom, setSelectedDateFrom] = React.useState(null)
  const [selectedDateTo, setSelectedDateTo] = React.useState(null)
  const [selectedDatePeriodFrom, setSelectedDatePeriodFrom] = React.useState(null)
  const [selectedDatePeriodTo, setSelectedDatePeriodTo] = React.useState(null)
  const handleDateFromChange = (date) => {
    setSelectedDateFrom(date)
    filterForm.setFieldValue('created_from', date || '')
  }
  const handleDateToChange = (date) => {
    setSelectedDateTo(date)
    filterForm.setFieldValue('created_to', date || '')
  }
  const handleDatePeriodFromChange = (date) => {
    setSelectedDatePeriodFrom(date)
    filterForm.setFieldValue('payment_tax_period_from', date || '')
  }
  const handleDatePeriodToChange = (date) => {
    setSelectedDatePeriodTo(date)
    filterForm.setFieldValue('payment_tax_period_to', date || '')
  }

  const filterForm = useFormik({
    initialValues: {
      receipt_number: '',
      request_number: '',
      payment_claim_number: '',
      payment_item: '',
      payment_tax_period_from: '',
      payment_tax_period_to: '',
      created_from: '',
      created_to: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: CompanyReceiptsFormValidation,
    onSubmit: ((values, actions) => {
      submitForm(values, actions)
    })
  })

  // const PaymentClaimItems = [
  //   {
  //     id: 0,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem'/>,
  //     value: ''
  //   },
  //   {
  //     id: 1,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.adoption_tax'/>,
  //     value: '1'
  //   },
  //   {
  //     id: 2,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.tax_differences_check'/>,
  //     value: '2'
  //   },
  //   {
  //     id: 3,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.compensation'/>,
  //     value: '3'
  //   },
  //   {
  //     id: 4,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.instead_of_confiscations'/>,
  //     value: '4'
  //   },
  //   {
  //     id: 5,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.za'/>,
  //     value: '5'
  //   },
  //   {
  //     id: 6,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.development_fees'/>,
  //     value: '6'
  //   },
  //   {
  //     id: 7,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.reconcile_fees'/>,
  //     value: '7'
  //   },
  //   {
  //     id: 8,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.Fines_and_compensation'/>,
  //     value: '9'
  //   },
  //   {
  //     id: 9,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.instead_of_confiscation'/>,
  //     value: '10'
  //   },
  //   {
  //     id: 10,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.extra_tax'/>,
  //     value: '15'
  //   },
  //   {
  //     id: 11,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.development_fee'/>,
  //     value: '17'
  //   },
  //   {
  //     id: 12,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.reconcile_fee'/>,
  //     value: '18'
  //   },
  //   {
  //     id: 13,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.Bounced_check_allowance'/>,
  //     value: '30'
  //   },
  //   {
  //     id: 14,
  //     name: <FormattedMessage id='PaymentHeader.paymentItem.other'/>,
  //     value: '99'
  //   }
  // ]
  // const handleClaimPaymentItemChange = (event) => {
  //   if (event) {
  //     event.preventDefault()
  //     event.stopPropagation()
  //   }
  //   filterForm.setFieldValue('payment_item', event.target.value.toString())
  // }
  const [expanded, setExpanded] = React.useState(false)
  const [width, setWidth] = React.useState(document.body.clientWidth)

  const handleCollapseChange = (event) => {
    setExpanded(!expanded)
  }

  let desktop = (width >= lg)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])
  return (
    <Accordion className={classes.filterWrapper}
               expanded={desktop || expanded}
               onChange={handleCollapseChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon/>}
        aria-label="Expand"
        aria-controls="companies-filter"
        id="companies-filter"
      >
        <h3 className={classes.filterTitle}><FormattedMessage id='Filter.Title'/></h3>
      </AccordionSummary>
      <AccordionDetails>
        <LanguageConsumer>
          {({ locale }) => (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
              <form onSubmit={filterForm.handleSubmit} noValidate autoComplete="off"
                    className={classes.formWrapper + ' center'}>
                <Grid container justify={'center'} wrap={'wrap'} className={classes.filtersFieldsWrapper}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      id="filterForm.receipt_number"
                      type={'text'}
                      margin="dense"
                      label={<FormattedMessage id='PaymentHeader.receiptNumber'/>}
                      variant="outlined"
                      name='receipt_number'
                      onChange={filterForm.handleChange}
                      onBlur={filterForm.handleBlur}
                      value={filterForm.values.receipt_number}
                      helperText={filterForm.errors.receipt_number && filterForm.touched.receipt_number && filterForm.errors.receipt_number}
                      error={filterForm.errors.receipt_number && filterForm.touched.receipt_number !== undefined}
                    />
                  </FormControl>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      id="filterForm.request_number"
                      type={'text'}
                      margin="dense"
                      label={<FormattedMessage id='PaymentHeader.requestNumber'/>}
                      variant="outlined"
                      name='request_number'
                      onChange={filterForm.handleChange}
                      onBlur={filterForm.handleBlur}
                      value={filterForm.values.request_number}
                      helperText={filterForm.errors.request_number && filterForm.touched.request_number && filterForm.errors.request_number}
                      error={filterForm.errors.request_number && filterForm.touched.request_number !== undefined}
                    />
                  </FormControl>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      id="filterForm.payment_claim_number"
                      type={'text'}
                      margin="dense"
                      label={<FormattedMessage id='PaymentHeader.climeNumber'/>}
                      variant="outlined"
                      name='payment_claim_number'
                      onChange={filterForm.handleChange}
                      onBlur={filterForm.handleBlur}
                      value={filterForm.values.payment_claim_number}
                      helperText={filterForm.errors.payment_claim_number && filterForm.touched.payment_claim_number && filterForm.errors.payment_claim_number}
                      error={filterForm.errors.payment_claim_number && filterForm.touched.payment_claim_number !== undefined}
                    />
                  </FormControl>

                  {/*<FormControl fullWidth margin={'dense'} variant='outlined'*/}
                  {/*             className={classes.formControl + ' ' + classes.formSelectControl}>*/}
                  {/*  <InputLabel id="payment-item-label"><FormattedMessage id='PaymentHeader.paymentItem'/></InputLabel>*/}
                  {/*  <Select*/}
                  {/*    fullWidth*/}
                  {/*    labelId="tax-type-label"*/}
                  {/*    id="payment_item"*/}
                  {/*    name="payment_item"*/}
                  {/*    MenuProps={{ disableScrollLock: true }}*/}
                  {/*    value={filterForm.values.payment_item}*/}
                  {/*    label={intl.formatMessage({ id: 'PaymentHeader.paymentItem' })}*/}
                  {/*    onChange={handleClaimPaymentItemChange}*/}
                  {/*    onBlur={filterForm.handleBlur}*/}
                  {/*    error={filterForm.errors.payment_item && filterForm.touched.payment_item !== undefined}*/}
                  {/*  >*/}
                  {/*    {PaymentClaimItems.map((item) => (*/}
                  {/*      <MenuItem key={item.id} value={item.value}>{item.name}</MenuItem>))}*/}
                  {/*  </Select>*/}
                  {/*  {filterForm.errors.payment_item && filterForm.touched.payment_item && (*/}
                  {/*    <FormHelperText error={true}>{filterForm.errors.payment_item}</FormHelperText>*/}
                  {/*  )}*/}
                  {/*</FormControl>*/}

                  <KeyboardDatePicker
                    fullWidth
                    className={classes.dateFormControl}
                    disableToolbar
                    variant="outlined"
                    format="dd-MM-yyyy"
                    margin='dense'
                    id="payment_tax_period_from"
                    name='payment_tax_period_from'
                    label={intl.formatMessage({ id: 'PaymentHeader.taxPeriodFrom' })}
                    value={selectedDatePeriodFrom}
                    onChange={handleDatePeriodFromChange}
                    onBlur={filterForm.handleBlur}
                    helperText={filterForm.errors.payment_tax_period_from && filterForm.touched.payment_tax_period_from &&
                    <FormattedMessage id='validationSchema.date'/>}
                    error={filterForm.errors.payment_tax_period_from && filterForm.touched.payment_tax_period_from !== undefined}
                    cancelLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.close' })}
                    okLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.Confirm' })}
                    KeyboardButtonProps={{
                      'aria-label': 'date from'
                    }}
                  />

                  <KeyboardDatePicker
                    fullWidth
                    className={classes.dateFormControl}
                    disableToolbar
                    variant="outlined"
                    format="dd-MM-yyyy"
                    margin='dense'
                    id="payment_tax_period_to"
                    name='payment_tax_period_to'
                    label={intl.formatMessage({ id: 'PaymentHeader.taxPeriodTo' })}
                    value={selectedDatePeriodTo}
                    onChange={handleDatePeriodToChange}
                    onBlur={filterForm.handleBlur}
                    helperText={filterForm.errors.payment_tax_period_to && filterForm.touched.payment_tax_period_to &&
                    <FormattedMessage id='validationSchema.date'/>}
                    error={filterForm.errors.payment_tax_period_to && filterForm.touched.payment_tax_period_to !== undefined}
                    cancelLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.close' })}
                    okLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.Confirm' })}
                    KeyboardButtonProps={{
                      'aria-label': 'date to'
                    }}
                  />

                  <KeyboardDatePicker
                    fullWidth
                    className={classes.dateFormControl}
                    disableToolbar
                    variant="outlined"
                    format="dd-MM-yyyy"
                    margin='dense'
                    id="created_from"
                    name='created_from'
                    label={intl.formatMessage({ id: 'Fields.placeholder.dateFrom' })}
                    value={selectedDateFrom}
                    onChange={handleDateFromChange}
                    onBlur={filterForm.handleBlur}
                    helperText={filterForm.errors.created_from && filterForm.touched.created_from &&
                    <FormattedMessage id='validationSchema.date'/>}
                    error={filterForm.errors.created_from && filterForm.touched.created_from !== undefined}
                    cancelLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.close' })}
                    okLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.Confirm' })}
                    KeyboardButtonProps={{
                      'aria-label': 'date from'
                    }}
                  />

                  <KeyboardDatePicker
                    fullWidth
                    className={classes.dateFormControl}
                    disableToolbar
                    variant="outlined"
                    format="dd-MM-yyyy"
                    margin='dense'
                    id="created_to"
                    name='created_to'
                    label={intl.formatMessage({ id: 'Fields.placeholder.dateTo' })}
                    value={selectedDateTo}
                    onChange={handleDateToChange}
                    onBlur={filterForm.handleBlur}
                    helperText={filterForm.errors.created_to && filterForm.touched.created_to &&
                    <FormattedMessage id='validationSchema.date'/>}
                    error={filterForm.errors.created_to && filterForm.touched.created_to !== undefined}
                    cancelLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.close' })}
                    okLabel={intl.formatMessage({ id: 'PaymentOrder.ActionLinks.Confirm' })}
                    KeyboardButtonProps={{
                      'aria-label': 'date to'
                    }}
                  />
                </Grid>
                <button type="submit" disabled={filterForm.isSubmitting || !filterForm.isValid}
                        className={classes.submitButton + ' noMargin'}>
                  <FormattedMessage id='Filter.button.submit'/>
                </button>
              </form>
            </MuiPickersUtilsProvider>
          )}
        </LanguageConsumer>
      </AccordionDetails>
    </Accordion>
  )
}

export default ReceiptsFilter
